import axiosService from './common/axios'

function selectCodeList () {
	return axiosService.get('statReport/selectCodeList')
}
function selectStatRpeortClass (paramData) {
	return axiosService.get('statReport/selectStatRpeortClass', { params: paramData })
}
function searchStatReportList (paramData) {
	return axiosService.get('statReport/statReportList', { params: paramData })
}
function updateStatReportVistCount (paramData) {
	return axiosService.post('statReport/updateStatReportVistCount', paramData)
}
function updateStatReportDownloadCount (paramData) {
	return axiosService.post('statReport/updateStatReportDownloadCount', paramData)
}
function integratedSearchStatReport (paramData) {
	return axiosService.get('statReport/integratedSearchStatReport', { params: paramData })
}

export { selectCodeList, searchStatReportList, updateStatReportVistCount, selectStatRpeortClass, updateStatReportDownloadCount, integratedSearchStatReport }
